export type SiNoPerfil = 'si' | 'no' | '';

export type BloquePerfil = 'identidad' | 'contacto' | 'diversidad' | 'familia';

export interface DireccionPerfil {
  tipo: string;
  paisResidencia: string;
  region: string;
  comuna: string;
  calleNumeroDepto: string;
  referenciaAdicional: string;
}

export function direccionPerfilVacia(): DireccionPerfil {
  return {
    tipo: '',
    paisResidencia: '',
    region: '',
    comuna: '',
    calleNumeroDepto: '',
    referenciaAdicional: '',
  };
}

export interface DatosPersonales {
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  runPasaporte: string;
  runBloqueado: boolean;
  nacionalidad: string;
  fechaNacimiento: string;
  /** Alias de género registral; se mantiene por otros módulos que aún leen este campo. */
  sexoRegistral: string;
  generoRegistral: string;
  generoDeclarativo: string;
  nombreSocialCompleto: string;
  correoPrincipal: string;
  correoAlternativo: string;
  telefono: string;
  direcciones: DireccionPerfil[];
  /** Sincronizados desde la primera dirección, para no romper postulaciones. */
  region: string;
  ciudad: string;
  pais: string;
  institucionActual: string;
  cargoRol: string;
  departamentoUnidad: string;
  tipoVinculo: string;
  linkedinAcademico: string;
  discapacidad: string;
  discapacidadSiNo: SiNoPerfil;
  pueblosOriginarios: string;
  puebloOriginario: SiNoPerfil;
  puebloAlQuePertenece: string;
  tieneHijos: SiNoPerfil;
  cantidadHijos: number | null;
  conyugeConviviente: string;
  ultimoBloque: BloquePerfil;
}

export function datosPersonalesVacios(): DatosPersonales {
  return {
    primerNombre: '',
    segundoNombre: '',
    primerApellido: '',
    segundoApellido: '',
    runPasaporte: '',
    runBloqueado: false,
    nacionalidad: '',
    fechaNacimiento: '',
    sexoRegistral: '',
    generoRegistral: '',
    generoDeclarativo: '',
    nombreSocialCompleto: '',
    correoPrincipal: '',
    correoAlternativo: '',
    telefono: '',
    direcciones: [direccionPerfilVacia()],
    region: '',
    ciudad: '',
    pais: '',
    institucionActual: '',
    cargoRol: '',
    departamentoUnidad: '',
    tipoVinculo: '',
    linkedinAcademico: '',
    discapacidad: '',
    discapacidadSiNo: '',
    pueblosOriginarios: '',
    puebloOriginario: '',
    puebloAlQuePertenece: '',
    tieneHijos: '',
    cantidadHijos: null,
    conyugeConviviente: '',
    ultimoBloque: 'identidad',
  };
}

export const CAMPOS_BLOQUE_PERFIL: Record<BloquePerfil, Array<keyof DatosPersonales>> = {
  identidad: [
    'primerNombre',
    'segundoNombre',
    'primerApellido',
    'segundoApellido',
    'runPasaporte',
    'runBloqueado',
    'nacionalidad',
    'fechaNacimiento',
    'nombreSocialCompleto',
  ],
  contacto: ['correoPrincipal', 'correoAlternativo', 'telefono', 'direcciones'],
  diversidad: [
    'generoRegistral',
    'sexoRegistral',
    'generoDeclarativo',
    'puebloOriginario',
    'puebloAlQuePertenece',
    'discapacidadSiNo',
  ],
  familia: ['tieneHijos', 'cantidadHijos', 'conyugeConviviente'],
};
